<template>
  <div class="container-fluid container-fluid px-4 rounded-4 contenedor-principal">
    <div class="bg-white py-4 rounded-4">
      <chat-operacion :id-operacion="props.idOperacion" :codigo-secuencial-operacion="props.codigoSecuencialOperacion" :tipo="props.tipoOperacion"
        :es-backoffice="true" @detalle-operacion="handleDetalleOperacion" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ChatOperacion from "@/.shared/components/chat-operacion/ChatOperacion.vue";
import { useRouter } from "@/.shared/services/routing-services";
import { TipoOperacionEnum } from "@/.shared/enums/TipoOperacionEnum";

const props = defineProps({
  idOperacion: {
    type: String,
    required: true
  },
  codigoSecuencialOperacion: {
    type: String,
    required: true
  },
  tipoOperacion: {
    type: String as () => TipoOperacionEnum,
    required: true
  }
});

const router = useRouter();

const handleDetalleOperacion = async () => {
  await router.push({ name: "tramite", query: { idOperacion: props.idOperacion, tipoOperacion: props.tipoOperacion } });
};

</script>